module.exports = __webpack_public_path__ + "img/company.f75cbb0e.png";